<template>
  <div>
    <div class="contract">
      <!-- <HeaderNL :groupService="dataContract.groupService"></HeaderNL> -->

      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập - Tự do - Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>

      <p class="txt-tranf txt-center fonsize-20" style="margin-top: 20px; margin-bottom: 20px">
        <b>YÊU CẦU HỖ TRỢ CHUYỂN GIAO DỮ LIỆU</b>
      </p>

      <p>Kính gửi: Công ty Cổ phần Công nghệ Vi Mô (Sau đây gọi tắt là "Vi Mô")</p>

      <p>Căn cứ:</p>
      <ol class="form-style2">
        <li>Luật Bảo vệ dữ liệu cá nhân số 91/2025/QH15;</li>
        <li>
          Nghị định 356/2025/NĐ-CP được ban hành để hướng dẫn chi tiết Luật Bảo vệ dữ liệu cá nhân
          số 91/2025/QH15;
        </li>
      </ol>

      <p>
        Đơn Vị Chấp Nhận Thanh Toán là chủ thể dữ liệu có thông tin dưới đây (“Chủ Thể Dữ Liệu”,
        “ĐVCNTT”)
      </p>

      <div class="form form-ext">
        <p>
          Tên ĐVCNTT:
          <mark>{{ customerInfo ? customerInfo.merchantName || '' : '' }}</mark>
        </p>
        <p>
          Địa chỉ:
          <mark
            >{{ customerInfo ? customerInfo.address : ''
            }}<template v-if="customerInfo && customerInfo.district"
              >, {{ customerInfo.district }}</template
            ><template v-if="customerInfo && customerInfo.city"
              >, {{ customerInfo.city }}</template
            ></mark
          >
        </p>
        <p>
          Email đăng ký dịch vụ:
          <span>{{ customerInfo && customerInfo.email ? customerInfo.email : '' }}</span>
        </p>
        <p>
          Điện thoại:
          <span>{{ customerInfo && customerInfo.mobile ? customerInfo.mobile : '' }}</span>
        </p>
        <p>
          Mã số thuế:
          <span>{{
            customerInfo && customerInfo.businessRegistrationNumber
              ? customerInfo.businessRegistrationNumber
              : ''
          }}</span>
        </p>
        <p>
          Đại diện:
          <b>{{ customerInfo && customerInfo.customerName ? customerInfo.customerName : '' }}</b>
          <span class="ml-4"
            >Chức vụ:
            <span>{{
              customerInfo && customerInfo.position ? customerInfo.position : ''
            }}</span></span
          >
        </p>
        <p>
          Giấy ủy quyền số: <span>....................................................</span> ngày
          ....../...../........ của
          <span>......................................................</span>
        </p>
        <p>
          Số CMND/CCCD:
          <span>{{ customerInfo?.passport }}</span>
          <span class="ml-4"
            >Nơi cấp: <span>{{ customerInfo?.placeOfIssue }}</span></span
          >
        </p>
        <p>
          SĐT:
          <span>{{
            customerInfo && customerInfo.authoriserContactNumber
              ? customerInfo.authoriserContactNumber
              : ''
          }}</span>
          <span class="ml-4"
            >Email:
            <span>{{
              customerInfo && customerInfo.authoriserEmail ? customerInfo.authoriserEmail : ''
            }}</span></span
          >
        </p>
      </div>

      <p style="text-align: justify; margin-top: 15px">
        Bằng văn bản này, ĐVCNTT xác nhận đã được Vi Mô thông báo đầy đủ về việc dừng cung cấp dịch
        vụ trung gian thanh toán. Để đảm bảo quyền lợi kinh doanh và duy trì sự liên tục trong việc
        sử dụng các dịch vụ trung gian thanh toán, ĐVCNTT đề nghị, chỉ định và cho phép Vi Mô, thay
        mặt ĐVCNTT thực hiện các công việc sau đây:
      </p>
      <ui class="ul-li-style">
        <li>Trích xuất và chuyển giao Dữ Liệu của ĐVCNTT sang cho:</li>
        <li>
          Công ty Cổ phần Cổng Trung Gian Thanh Toán Ngân Lượng, địa chỉ: Tầng 3, Tòa nhà VTC
          Online, số 18, đường Tam Trinh, Phường Tương Mai, TP Hà Nội, Việt Nam. Mã số doanh nghiệp:
          0106001236 ("<b>Ngân Lượng</b>").
        </li>
        <p style="text-align: justify">
          Việc chuyển giao Dữ Liệu này được thực hiện dựa trên nhu cầu và lợi ích của ĐVCNTT nhằm
          mục đích để Ngân Lượng thực hiện quy trình liên hệ tới khách hàng nhằm thiết lập hồ sơ
          khách hàng, thực hiện thủ tục nhận biết khách hàng (KYC), ký hợp đồng và cung cấp các dịch
          vụ trung gian thanh toán cho ĐVCNTT (“Mục Đích”).
        </p>

        <li style="text-align: justify">
          Vi Mô và Ngân Lượng được tự do thỏa thuận về việc chuyển giao Dữ Liệu, bao gồm không giới
          hạn phương thức, biện pháp, ứng dụng, thiết bị liên quan đến việc chuyển giao dữ liệu để
          đảm bảo tính bảo mật và an toàn theo quy định pháp luật về bảo mật thông tin.
        </li>
        <li style="text-align: justify">
          Phạm vi dữ liệu của ĐVCNTT được chuyển giao (“Dữ Liệu”) bao gồm:
          <ol class="form-style2">
            <li>Tên;</li>
            <li>Địa chỉ;</li>
            <li>Số điện thoại liên hệ;</li>
            <li>Hình ảnh giấy phép kinh doanh;</li>
            <li>Hình ảnh các giấy tờ kinh doanh có điều kiện (nếu có);</li>
            <li>Hình ảnh các văn bản ủy quyền, cam kết (nếu có);</li>
            <li>Hình ảnh giấy tờ tùy thân của người đại diện pháp luật, đại diện ký hợp đồng;</li>
            <li>Hình ảnh địa điểm kinh doanh;</li>
            <li>Trang kinh doanh, quảng cáo online : website, page… (nếu có);</li>
          </ol>
        </li>
      </ui>

      <b style="text-align: justify">ĐVCNTT xác nhận và đồng ý rằng:</b>
      <ol class="form-style2">
        <li style="text-align: justify">
          Việc yêu cầu hỗ trợ chuyển giao Dữ Liệu của ĐVCNTT tại văn bản này là hoàn toàn tự nguyện
          và dựa trên nhu cầu thực tế của ĐVCNTT. ĐVCNTT cam kết sẽ không khiếu nại, khiếu kiện hoặc
          để xảy ra một vụ tranh chấp nào với Vi Mô liên quan đến việc Vi Mô thực hiện các công việc
          theo đề nghị của ĐVCNTT tại văn bản này.
        </li>
        <li style="text-align: justify">
          Vi Mô không phải chịu trách nhiệm đối với rủi ro phát sinh từ việc chuyển giao này, trừ
          trường hợp do lỗi cố ý sử dụng thông tin sai Mục Đích nêu tại văn bản này.
        </li>
      </ol>

      <p style="text-align: justify">
        ĐVCNTT xác nhận đã tìm hiểu và chấp thuận chính sách bảo mật của Vi Mô, Ngân Lượng trước khi
        ký văn bản này.
      </p>

      <div class="table-responsive" style="margin-top: 50px">
        <table class="table" style="border: unset !important">
          <tr>
            <td width="50%" align="center" style="vertical-align: top; border: 0 !important"></td>
            <td width="50%" align="center" style="vertical-align: top; border: 0 !important">
              <p style="text-align: center !important">
                <b>CHỦ THỂ DỮ LIỆU XÁC NHẬN</b><br />
                <i>(Ký và ghi rõ họ tên)</i>
              </p>
              <img v-if="dataSign" :src="dataSign" class="sign-block" alt="" />
              <img
                v-else-if="
                  dataAppendix &&
                  dataAppendix.typeCustomer &&
                  dataAppendix.typeCustomer === 'COMPANY'
                "
                src="@/assets/img/signature.png"
                class="sign-block"
              />
              <img v-else src="@/assets/img/signature.png" class="sign-block" />
              <br />
              <br />
              <strong>{{ customerInfo.customerName }}</strong>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  // import HeaderNL from '../block/headerNL.vue'
  // import FooterNL from '../block/footerNL.vue'

  export default {
    props: ['dataContract', 'appendix'],
    components: {
      // HeaderNL,
      // FooterNL,
    },
    data() {
      return {}
    },
    computed: {
      customerInfo() {
        return this.dataContract?.customerInfoRes ?? this.dataContract?.customerInfoCommon ?? {}
        // const baseInfo =
        //   this.dataContract?.customerInfoRes ?? this.dataContract?.customerInfoCommon ?? {}
        // const converts = this.dataContract?.lstAppendixNganluongConverts || []
        // const convertApp = converts.find(s => s.isCreatedWithContract) || converts[0]
        // const convertData = convertApp?.appendixNganluongConvert

        // if (convertData && Object.keys(convertData).length > 0) {
        //   return {
        //     ...baseInfo,
        //     merchantName: convertData.invoiceMcName || baseInfo.merchantName,
        //     address: convertData.invoiceMcAddress || baseInfo.address,
        //     email: convertData.invoiceMcEmail || baseInfo.email,
        //     mobile: convertData.invoiceMcMobile || baseInfo.mobile,
        //     businessRegistrationNumber:
        //       convertData.invoiceMcBusinessNumber || baseInfo.businessRegistrationNumber,
        //     customerName: convertData.invoiceMcContactName || baseInfo.customerName,
        //     position: convertData.invoiceMcContactPosition || baseInfo.position,
        //   }
        // }
        // return baseInfo
      },
      dataAppendix() {
        const converts = this.dataContract?.lstAppendixNganluongConverts || []
        const convertApp = converts.find(s => s.isCreatedWithContract) || converts[0]
        return this.appendix || convertApp || {}
      },
      dataSign() {
        if (this.dataAppendix?.isCreatedWithContract) {
          return this.dataContract?.signatureOfMerchantByContract?.[0] ?? null
        } else {
          return this.dataAppendix?.signatureOfMerchantByAppendix?.[0]
        }
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
<style scoped>
  .sign-block {
    width: 150px;
    height: 150px;
    display: inline-block;
  }
  .ul-li-style {
    list-style: auto;
  }
  .ul-li-style li {
    margin-left: 20px;
  }
</style>
